module.exports = __webpack_public_path__ + "img/IMG_1156_L_Wood.6d4df5f2.jpg";